import { useLazyQuery } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';
import { useVimAuth } from '@getvim/internal-vim-os-sdk/react';
import { internalApi } from '../internal-api';
import { orderAssistLogger } from '../components/app/logger';
import { GET_DATASOURCE_CONFIG } from '../internal-api/order-assist-bff/queries';
import { DatasourceConfig } from '../components/app/types';

export const useDatasourcesConfig = () => {
  const { accessToken } = useVimAuth();
  const [datasourceConfig, setDatasourceConfig] = useState<DatasourceConfig[]>();

  const [getDatasourceConfig, { data, error, loading }] = useLazyQuery(GET_DATASOURCE_CONFIG, {
    fetchPolicy: 'no-cache',
    client: internalApi.orderAssistBff.getClientForSdk(),
  });
  useEffect(() => {
    if (!datasourceConfig && accessToken) {
      getDatasourceConfig();
    }
  }, [accessToken, datasourceConfig, getDatasourceConfig]);

  useEffect(() => {
    if (!loading) {
      if (error) {
        orderAssistLogger.warning('Failed to fetch getDatasourceConfig query', { error });
      } else if (data) {
        setDatasourceConfig(data.getDatasourceConfig);
      }
    }
  }, [error, data, loading]);

  return useMemo(() => {
    return datasourceConfig;
  }, [datasourceConfig]);
};
